import { render } from "./ConfigurePopUpMessage.vue?vue&type=template&id=83adc394&scoped=true"
import script from "./ConfigurePopUpMessage.vue?vue&type=script&lang=js"
export * from "./ConfigurePopUpMessage.vue?vue&type=script&lang=js"

import "./ConfigurePopUpMessage.vue?vue&type=style&index=0&id=83adc394&lang=css"
import "./ConfigurePopUpMessage.vue?vue&type=style&index=1&id=83adc394&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83adc394"]])

export default __exports__